import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type MessageDraftsListByEventQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type MessageDraftsListByEventQuery = {
  __typename?: 'Query';
  messageDraftsByEvent: Array<{
    __typename?: 'MessageDraft';
    id: string;
    channel: Types.MessageDraftChannel;
    messageType?: string | null;
    messageBatchId: string;
    displayLabel: string;
    status: Types.MessageDraftStatus;
    scheduledAt?: any | null;
    updatedAt: any;
    failureReason?: string | null;
    recipientType: Types.MessageDraftRecipientType;
    recipientIds: Array<string>;
  }>;
};

export type DeleteMessageDraftMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  eventId: Types.Scalars['ID'];
}>;

export type DeleteMessageDraftMutation = { __typename?: 'Mutation'; deleteMessageDraft: boolean };

export const MessageDraftsListByEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MessageDraftsListByEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messageDraftsByEvent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'channel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageBatchId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'scheduledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'failureReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipientType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recipientIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useMessageDraftsListByEventQuery__
 *
 * To run a query within a React component, call `useMessageDraftsListByEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageDraftsListByEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageDraftsListByEventQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useMessageDraftsListByEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessageDraftsListByEventQuery, MessageDraftsListByEventQueryVariables>) {
  return ApolloReactHooks.useQuery<MessageDraftsListByEventQuery, MessageDraftsListByEventQueryVariables>(MessageDraftsListByEventDocument, baseOptions);
}
export function useMessageDraftsListByEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageDraftsListByEventQuery, MessageDraftsListByEventQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<MessageDraftsListByEventQuery, MessageDraftsListByEventQueryVariables>(MessageDraftsListByEventDocument, baseOptions);
}
export type MessageDraftsListByEventQueryHookResult = ReturnType<typeof useMessageDraftsListByEventQuery>;
export type MessageDraftsListByEventLazyQueryHookResult = ReturnType<typeof useMessageDraftsListByEventLazyQuery>;
export type MessageDraftsListByEventQueryResult = Apollo.QueryResult<MessageDraftsListByEventQuery, MessageDraftsListByEventQueryVariables>;
export const DeleteMessageDraftDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteMessageDraft' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMessageDraft' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type DeleteMessageDraftMutationFn = Apollo.MutationFunction<DeleteMessageDraftMutation, DeleteMessageDraftMutationVariables>;

/**
 * __useDeleteMessageDraftMutation__
 *
 * To run a mutation, you first call `useDeleteMessageDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageDraftMutation, { data, loading, error }] = useDeleteMessageDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useDeleteMessageDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMessageDraftMutation, DeleteMessageDraftMutationVariables>) {
  return ApolloReactHooks.useMutation<DeleteMessageDraftMutation, DeleteMessageDraftMutationVariables>(DeleteMessageDraftDocument, baseOptions);
}
export type DeleteMessageDraftMutationHookResult = ReturnType<typeof useDeleteMessageDraftMutation>;
export type DeleteMessageDraftMutationResult = Apollo.MutationResult<DeleteMessageDraftMutation>;
export type DeleteMessageDraftMutationOptions = Apollo.BaseMutationOptions<DeleteMessageDraftMutation, DeleteMessageDraftMutationVariables>;
